const LogsPage = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-primary">Napló</h1>
      <p className="mt-4 text-foreground/80">Itt tekintheted meg a rendszer naplóbejegyzéseit.</p>
    </div>
  );
};

export default LogsPage;